<div [hidden]="isUploading" class="file-upload">
  <p-fileUpload
    (onBeforeUpload)="onBeforeUpload()"
    (onError)="onError()"
    (onProgress)="onProgress($event)"
    (onSelect)="onSelect($event)"
    (onUpload)="onUpload($event)"
    [accept]="videoFormat"
    [chooseIcon]="chooseIcon"
    [disabled]="isUploading"
    [fileLimit]="fileLimit"
    [headers]="headers"
    [invalidFileLimitMessageDetail]="
      errorConfig?.invalidFileLimitMessageDetail || ''
    "
    [invalidFileLimitMessageSummary]="
      errorConfig?.invalidFileLimitMessageSummary || ''
    "
    [invalidFileSizeMessageDetail]="
      errorConfig?.invalidFileSizeMessageDetail || ''
    "
    [invalidFileSizeMessageSummary]="
      errorConfig?.invalidFileSizeMessageSummary || ''
    "
    [invalidFileTypeMessageDetail]="
      errorConfig?.invalidFileTypeMessageDetail || ''
    "
    [invalidFileTypeMessageSummary]="
      errorConfig?.invalidFileTypeMessageSummary || ''
    "
    [maxFileSize]="maxSizeVideo"
    [url]="fileUploadUrl"
    auto="true"
    chooseLabel="{{ 'label_upload_video' | translate }}"
    mode="basic"
    style="background-color: #25afb5"
    name="files"
  ></p-fileUpload>
</div>

<div *ngIf="isUploading" class="col-12">
  <div *ngIf="!isUploaded" class="upload-para" translate>
    label_uploading
    <span>{{ progressValue }}%</span>
  </div>
  <div *ngIf="isUploaded" class="upload-para" translate>
    <!-- label_uploaded -->
    {{ afterVideoUploadText }}
  </div>
  <div class="grid">
    <div class="col-10 lg:col-12 md:col-7 sm:col-8">
      <p-progressBar
        [showValue]="false"
        [value]="progressValue"
      ></p-progressBar>
    </div>
  </div>
</div>

<video
  #durationMeter
  (loadedmetadata)="checkDuration($event)"
  class="duration-meter"
  playsinline
  preload="auto"
  style="visibility: hidden; position: absolute; left: 1000em"
  webkit-playsinline="true"
></video>
